import { 
    RATE_CONFIG_DATA,
    GET_RATE_CONFIG_DATA,
    SET_RATES_CONFIG_STEPS,
    SET_EXISTING_RATES_CONFIG_STEPS,
    SET_RATESHEET_CONFIG_VARIABLES,
    SET_WINDOW_FIELDS_DATA,
    SET_RATES_CONFIG_STEPS_COPY
 } from "../actionTypes/RateConfigActionTypes";

const initialState = {
    reportData : null,
    rateSheetConfigVariables:{
        variablesList:[],
        constantsList:[],
        rateSheetsList:[],
        taxVariablesList:[]
    },
    ratesConfigSteps:[],
    ratesConfigStepsCopy:[],
    ratesExistingConfigSteps:[],
    windowDataFields:{},
    existState : null
}
const RateConfigReducer = (state = initialState, action) => {
    const {rateSheetConfigVariables,windowDataFields } = state;
    const {type,payload} = action;
    let updateRatesConfigSteps = null,updateRatesExistingConfigSteps = null,updateWindowDataFields=null,winId=null,value=null,updateRatesConfigStepsCopy=null;
    switch (type) {
        case SET_RATES_CONFIG_STEPS:
            updateRatesConfigSteps = [
                ...payload,
            ]
            return{
                ...state,
                ratesConfigSteps: updateRatesConfigSteps 
            }
        case SET_RATES_CONFIG_STEPS_COPY:
            updateRatesConfigStepsCopy = [
                ...payload,
            ]
            return{
                ...state,
                ratesConfigStepsCopy: updateRatesConfigStepsCopy 
            }
        case SET_EXISTING_RATES_CONFIG_STEPS:
            updateRatesExistingConfigSteps = [
                ...payload,
            ]
            return{
                ...state,
                ratesExistingConfigSteps: updateRatesExistingConfigSteps 
            }
        case SET_RATESHEET_CONFIG_VARIABLES:
            const {global_variables,global_constants,rate_sheet_list,tax_variables} = payload;
            let updateVariables = {
                ...rateSheetConfigVariables,
                variablesList:global_variables,
                constantsList:global_constants,
                rateSheetsList:rate_sheet_list,
                taxVariablesList:tax_variables
            }
            return{
                ...state,
                rateSheetConfigVariables:updateVariables
            }
        case SET_WINDOW_FIELDS_DATA:
            winId = payload.winId;
            value = payload.value;
            updateWindowDataFields={
                ...windowDataFields,
                [winId]:value
            }
            return{
                ...state,
                windowDataFields:updateWindowDataFields
            }    
        case RATE_CONFIG_DATA:
            return {
                ...state,
                reportData: action.payload,
                existState: action.existState
            };  
        case GET_RATE_CONFIG_DATA:
            return state.reportData;
        default:
            return state;
    }
    
}
export default RateConfigReducer;